import { useMemo } from 'react'

import { Dropdown } from 'core-components/library/dropdown'
import { TWrapValues } from 'core-components/sitebuilder/models/flexGrid/IFlexItem'
import { BaseCrud, Static } from 'core-components/types'

interface IWrapperActionsSelector {
  value: TWrapValues
  onChange: (newValue: TWrapValues) => void
  className?: string
}

export const FlexWrapperWrapSelector = ({
  value,
  onChange,
  className,
}: IWrapperActionsSelector) => {
  const source = useMemo(() => {
    return new BaseCrud({
      fetcher: new Static([
        {
          id: 'wrap',
          label: 'Wrap',
        },
        {
          id: 'noWrap',
          label: 'No wrap',
        },
      ]),
      keyField: 'id',
    })
  }, [])

  return (
    <Dropdown
      classes={{ controlClasses: { root: className } }}
      caption={'label'}
      source={source}
      onChange={(newValue) => onChange(newValue as TWrapValues)}
      value={value}
    />
  )
}
